// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "CAD/CAM技术基础",
      "tec": "王炳达",
      "week": "1-12周",
      "add": "教学楼A座215机房"
    },
    {
      "sub": "机械设计",
      "tec": "李祥松",
      "week": "1-12周",
      "add": "教学楼A座420机械"
    },
    {
      "sub": "液压与气压传动（双语）",
      "tec": "张修路",
      "week": "1-12周",
      "add": "教学楼A座319机械"
    },
    [
      {
        "sub": "工程有限元与数值计算",
        "tec": "田阳范智广",
        "week": "1-8周",
        "add": "教学楼A座215机房"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "9-12周",
        "add": "教学楼A座225电力"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "周彩虹",
      "week": "1-5,7-9周",
      "add": "教学楼A座222电力"
    },
    {
      "sub": "机械工程控制基础",
      "tec": "赵群",
      "week": "1-8周",
      "add": "教学楼A座319机械"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "滕志飞鲍洁秋",
      "week": "6-13周",
      "add": "教学楼A座418机械"
    },
    {
      "sub": "液压与气压传动（双语）",
      "tec": "张修路",
      "week": "1-12周",
      "add": "教学楼A座319机械"
    },
    0,
    {
      "sub": "工程有限元与数值计算",
      "tec": "田阳范智广",
      "week": "1-8周",
      "add": "教学楼A座215机房"
    },
    0
  ],
  "4": [
    {
      "sub": "机械设计",
      "tec": "李祥松",
      "week": "1-12周",
      "add": "教学楼A座420机械"
    },
    {
      "sub": "机械工程控制基础",
      "tec": "赵群",
      "week": "1-8周",
      "add": "教学楼A座319机械"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "周彩虹",
      "week": "1-5,7-9周",
      "add": "教学楼A座326电力"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "就业创业指导",
      "tec": "夏海明",
      "week": "9-13周",
      "add": "教学楼C座112教务"
    },
    0,
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "9-12周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "CAD/CAM技术基础",
      "tec": "王炳达",
      "week": "1-12周",
      "add": "教学楼A座215机房"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
